"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var MiniIcons = _interopRequireWildcard(require("@heroicons/react/20/solid"));
var OutlineIcons = _interopRequireWildcard(require("@heroicons/react/24/outline"));
var SolidIcons = _interopRequireWildcard(require("@heroicons/react/24/solid"));
var _types = require("./types");
var Styled = _interopRequireWildcard(require("./style"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var getIcon = function getIcon(icon, variant) {
  var iconComponent = null;
  switch (variant) {
    case _types.IconVariants.Mini:
      //@ts-ignore
      iconComponent = MiniIcons["".concat(icon, "Icon")];
      break;
    case _types.IconVariants.Outline:
      //@ts-ignore
      iconComponent = OutlineIcons["".concat(icon, "Icon")];
      break;
    case _types.IconVariants.Solid:
      //@ts-ignore
      iconComponent = SolidIcons["".concat(icon, "Icon")];
      break;
    default:
      console.warn("Invalid icon variant, couldn't find the requested icon: ".concat(icon, " with variant: ").concat(variant, ", defaulting to \"solid\""));
      //@ts-ignore
      iconComponent = SolidIcons["".concat(icon, "Icon")];
      break;
  }
  return iconComponent;
};
var Icon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var icon = props.icon,
    _a = props.variant,
    variant = _a === void 0 ? 'outline' : _a,
    _b = props.spin,
    spin = _b === void 0 ? false : _b,
    size = props.size,
    className = props.className,
    style = props.style,
    onClick = props.onClick,
    // @ts-ignore, quick ugly fix to remove unused props and prevent the prop from being passed to the icon component.
    variantType = props.variantType,
    filteredProps = __rest(props, ["icon", "variant", "spin", "size", "className", "style", "onClick", "variantType"]);
  var IconComponent = (0, _react.useMemo)(function () {
    return getIcon(icon, variant);
  }, [icon, variant]);
  var content = IconComponent ? (0, _jsxRuntime.jsx)(IconComponent, __assign({}, filteredProps, {
    ref: undefined
  })) : null;
  return (0, _jsxRuntime.jsx)(Styled.Span, __assign({
    ref: ref,
    style: style,
    "$size": size,
    "$spin": spin,
    onClick: onClick,
    className: "fluffy-icon ".concat(className ? className : '')
  }, {
    children: content
  }));
});
Icon.displayName = 'Icon';
var _default = Icon;
exports.default = _default;